export function isNil(value) {
    return value === null || value === undefined;
}

export const az = (numb) => `${numb < 10 ? "0" : ""}${numb}`;
